import { render, staticRenderFns } from "./EditDeck.vue?vue&type=template&id=0d818cbf&"
import script from "./EditDeck.vue?vue&type=script&lang=js&"
export * from "./EditDeck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports